import React from 'react';
import CustomerDashboard from 'pages/Customer/Dashboard';
import CustomerCatalog from 'pages/Customer/Catalog';
import CustomerProducts from 'pages/Customer/Products';
import CustomerProductDetail from 'pages/Customer/ProductDetail';
import ShoppingCart from 'pages/Ecommerce/ShoppingCart';
import Checkout from 'pages/Ecommerce/Checkout';
import Orders from 'pages/Ecommerce/Order/Orders';
import OrderDetail from 'pages/Ecommerce/Order/OrderDetail';
import Wishlist from 'pages/Ecommerce/Wishlist/Wishlist';
import UserProfile from 'pages/Authentication/UserProfile';

interface RouteObject {
  path: string;
  component: React.ComponentType<any>;
  exact?: boolean;
}

export const customerRoutes: Array<RouteObject> = [
  { path: '/customer/dashboard', component: CustomerDashboard },
  { path: '/customer/catalog', component: CustomerCatalog },
  { path: '/customer/products', component: CustomerProducts },
  { path: '/customer/products/:productId', component: CustomerProductDetail },
  { path: '/customer/cart', component: ShoppingCart },
  { path: '/customer/checkout', component: Checkout },
  { path: '/customer/orders', component: Orders },
  { path: '/customer/order-detail/:orderId', component: OrderDetail },
  { path: '/customer/wishlist', component: Wishlist },
  { path: '/customer/profile', component: UserProfile },
];
